import React from "react";
import {Button, Col, Form, Input, Modal, Row} from "antd";
import {updateAddressBeneficiary} from "../../api/api";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class BeneficiaryAddressModal extends React.Component {
    state = {
        beneficiaryAddress: ''
    }
    onOk = () => {
        let beneficiaryId = this.props.beneficiaryId;
        updateAddressBeneficiary(beneficiaryId, this.state.beneficiaryAddress).then((response) => {
            if (response.addressLine1) {
                this.props.finishSelectedAddress(response)
            }

        })

    }

    render() {
        const intl = this.props.useIntl;
        return (
            <Modal
                className="bp-modal"
                title={intl.formatMessage({id: "app.modal.beneficiaryaddressmodal.addbeneficiaryaddress"})}
                visible={this.props.visible}
                onOk={this.onOk}
                onCancel={this.props.onCancel}
                okButtonProps={{ disabled: !this.state.beneficiaryAddress }}
                maskClosable={false}
                destroyOnClose={true}
                width="1024px"
                style={{top: "50px"}}
            >
                <Row gutter={16}>
                    <Col md={24}>
                        <Form.Item
                            required={true}
                            hasFeedback>
                            <Input
                                name="beneficiaryAddress"
                                size={"large"}
                                value={this.state.beneficiaryAddress}
                                onChange={e => this.setState({beneficiaryAddress: e.target.value})}
                            />
                        </Form.Item>
                    </Col>
                </Row>


            </Modal>
        )
    }
}

export default withUseIntl(BeneficiaryAddressModal);